
/* -------------------------------------

	Header

------------------------------------- */

$(document).ready(function() {

	
	$(window).bind('scroll', function(e) {

		
		var body = $('body');
		var nav = $('body > div.top');
		var header = $('header');
		var scroll = $(this).scrollTop();


		if (scroll >= nav.height()) {

			body.addClass('scroll');
			header.addClass('fixed');

			return false;

		}


		body.removeClass('scroll');
		header.removeClass('fixed');


	});


	/* meganav */
	$('header > .container > nav li').hover(function() {

		if ($(window).width() > 992) {
			$(this).find('nav.mega').stop(true, true).fadeIn(250).addClass('active');
		}

	}, function() {

		if ($(window).width() > 992) {
			$(this).find('nav.mega').stop(true, true).fadeOut(250).removeClass('active');
		}

	});


	/* toggle */
	$('header #toggle').click(function() {

		$(this).toggleClass('active');
		$('header > .container > nav').toggleClass('active');

	});

	/* mobile */
	$('header > .container > nav li a.expand').click(function() {

		if ($(window).width() < 992) {

			var current = $(this).siblings('nav.expand');

			if(current.hasClass('active')) {

				$(this).removeClass('active');
				current.removeClass('active');

				return false;

			}

			$('header a.expand').removeClass('active');
			$('header nav.expand').removeClass('active');
			
			$(this).addClass('active');
			$(this).siblings('nav.expand').toggleClass('active');

			return false;

		}

	});

});


